import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import React from 'react'

import {
  type ConfigSettingsProps,
  type ConfigSettingsState,
  useConfigSettingsState,
} from './useConfigSettingsState'

export const ConfigSettingsBase: React.FC<
  Pick<ConfigSettingsProps, 'orgID'> & {
    renderTrigger: (state: ConfigSettingsState) => React.ReactNode
    renderContent: (state: ConfigSettingsState) => React.ReactNode
  }
> = ({ orgID, renderContent, renderTrigger }) => {
  const state = useConfigSettingsState({ orgID })

  if (!state.shouldRender) {
    return null
  }

  return (
    <DropdownMenu.Root open={state.isOpen} onOpenChange={state.setIsOpen}>
      {renderTrigger(state)}
      {renderContent(state)}
    </DropdownMenu.Root>
  )
}
